module.exports = __webpack_public_path__ + "5e8a36aad1e317f5e28283185eceaeca.MP3";